module.exports = __webpack_public_path__ + "img/front-light.6f719ce2.png";